export const clinicalMeetingActivitiesSagas = [];
